import React, { useEffect, useState } from 'react';

interface ResponseTimerProps {
    isRunning: boolean;
    startTime: number | null;
    onTimeUpdate?: (elapsedTime: number) => void;
}

const ResponseTimer: React.FC<ResponseTimerProps> = ({
    isRunning,
    startTime,
    onTimeUpdate
}) => {
    const [elapsedTime, setElapsedTime] = useState(0);

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (isRunning && startTime) {
            interval = setInterval(() => {
                const currentTime = Date.now();
                const elapsed = Math.floor((currentTime - startTime) / 1000);
                setElapsedTime(elapsed);
                onTimeUpdate?.(elapsed);
            }, 1000);
        } else if (!isRunning) {
            setElapsedTime(0);
        }

        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [isRunning, startTime, onTimeUpdate]);

    const formatTime = (seconds: number): string => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    return (
        <div className="fixed top-20 right-4 z-50 bg-blue-600 text-white px-3 py-2 rounded-lg shadow-lg font-mono text-sm">
            <div className="flex items-center space-x-2">
                {isRunning && <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>}
                <span>Response Time: {formatTime(elapsedTime)}</span>
            </div>
        </div>
    );
};

export default ResponseTimer; 